import store from '@/store/index';
import Comment from './Comment';
import AccessType from './AccessType';
import User from './User';
import Organization from './Organization';
import StatusType from './typelist/StatusType';
import FirebaseUtil from './FirebaseUtil';
import { COLLECTION_ORGANIZATIONS, COLLECTION_POSTS, COLLECTION_USERS } from './AppConstants';
import PostType from './typelist/PostType';
import PostTile from './PostTile';

export default class Post {
    comments: Comment[] = [];

    content: string;

    likes: User[] = [];

    createdTime: Date = new Date();

    createdBy: any;

    access?: AccessType;

    photoURLList?: string[] = [];

    status?: StatusType;

    organization?: Organization;

    postTile?: PostTile;

    type?: PostType;

    userViews?: string[]= [];

    constructor(_text: string, _createdBy: any) {
      this.content = _text;
      this.createdBy = _createdBy;
    }

    static convertToObj(post: any) {
      const postObj = { ...post };
      if (post.organization) {
        postObj.organization = FirebaseUtil.ObjectToRef(
          COLLECTION_ORGANIZATIONS,
          post.organization.id,
        );
      }
      return postObj;
    }

    static updateStatus(post: any, status: StatusType) {
      const postObj = { ...post };
      postObj.status = { ...status };
      postObj.createdBy = FirebaseUtil.ObjectToRef(COLLECTION_USERS, post.createdBy.uid);
      const postCmts = [] as any;
      post.comments.forEach((cmt: any) => {
        const cmtObj = new Comment(cmt.text,
          FirebaseUtil.ObjectToRef(COLLECTION_USERS, cmt.createdBy.uid));
        cmtObj.createdTime = cmt.createdTime;
        postCmts.push({ ...cmtObj });
      });
      postObj.comments = postCmts;
      store.dispatch('updateCollection', {
        collection: COLLECTION_POSTS,
        doc: post.id,
        payload: postObj,
      });
    }
}
